import { DateTime } from '@components/dateTime/DateTime';

type ZineDatelineProps = {
	isRelative?: boolean;
	publishedAt: string | null;
	updatedAt: string;
};

export const ZineDateline = ({
	publishedAt,
	updatedAt,
	isRelative = true,
}: ZineDatelineProps) => {
	const date = new Date(publishedAt || updatedAt);

	return (
		<p className="font-t6-medium">
			Posted <DateTime date={date} isRelative={isRelative} />
		</p>
	);
};
